import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { apiGet } from '../../api/client';
import '../../styles/admin.css';

export default function AdminGuard() {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    apiGet('/admin/me')
      .then(() => setStatus('ok'))
      .catch(() => setStatus('fail'));
  }, []);

  if (status === 'loading') {
    return <div className="admin-page"><p>Checking session...</p></div>;
  }

  if (status === 'fail') {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
}
